<template>
	<!-- 数据备份 列表页 -->
	<div class="board">
		<div v-hasPermi="['backup:list']">
			<div class="title">
				<span class="name">{{ backupTextConfig.title }}</span>
			</div>

			<el-form :inline="true" :model="form" ref="form">
				<el-form-item>
					<el-select v-model="form.examPlanId" filterable clearable :placeholder="searchTextConfig.examPlanId">
						<el-option v-for="(item,index) in examPlanOptions" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="form.subjectId" filterable clearable :placeholder="searchTextConfig.subjectId">
						<el-option v-for="(item,index) in subjectOptions" :key="index" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search(1)">{{ searchTextConfig.select }}</el-button>
					<el-button @click="reset">{{ searchTextConfig.reset }}</el-button>
				</el-form-item>
			</el-form>
			<p class="info">
				<el-button v-hasPermi="['backup:backing']" :disabled="selectRow.length == 0 || selectRow.some(item => item.backupStatus != 'online')" @click="backup(selectRow)" type="success" size="mini">
					{{ batchTextConfig.backing.name }}
				</el-button>
				<el-button v-hasPermi="['backup:download']" :disabled="selectRow.length == 0 || selectRow.some(item => item.backupStatus != 'backed')" @click="download(selectRow)" type="primary" size="mini">
					{{ batchTextConfig.donwload.name }}
				</el-button>
				<el-button v-hasPermi="['backup:delete']" :disabled="selectRow.length == 0 || selectRow.some(item => item.backupStatus == 'backing' || item.backupStatus == 'deleted')" @click="del(selectRow)" type="danger" size="mini">
					{{ batchTextConfig.remove.name }}
				</el-button>
			</p>
			<p style="margin-top: 10px; margin-bottom: 20px">
				<span>
				  {{infoTextConfig.count}}：<span style="color: #409eff">{{summaryData.count}}</span>
				</span>
				<span style="margin-left: 20px;">
				  {{infoTextConfig.total}}：<span style="color: #409eff">{{formatFileSize(summaryData.total)}}</span>
				</span>
			</p>
			<el-table :data="tableData" v-loading="loading" element-loading-text="加载中"
			          element-loading-spinner="el-icon-loading" ref="multipleTable"
			          @selection-change="handleSelectionChange" stripe size="medium" :height="height"
			          style="width:100%">
				<el-table-column type="selection" width="48" fixed="left" align="center"></el-table-column>
				<el-table-column prop="exam.examPlan.name" :label="tableTextConfig.examPlanName" min-width="140px" show-overflow-tooltip></el-table-column>
				<el-table-column prop="exam.subject" :label="tableTextConfig.subject" min-width="120px"></el-table-column>
				<el-table-column :label="tableTextConfig.examTime" min-width="140px" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ examTimeFormatter(scope.row.exam) }}
					</template>
				</el-table-column>
				<el-table-column :label="tableTextConfig.backupTime" min-width="140px" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.backupStatus === 'backed' && scope.row.updatedAt ? formatDateTime(scope.row.updatedAt) : ''}}
					</template>
				</el-table-column>
				<el-table-column prop="fileSize" :label="tableTextConfig.fileSize" width="160px">
					<template slot-scope="scope">
						{{ scope.row.backupStatus === 'backed' ? formatFileSize(scope.row.fileSize) : ''}}
					</template>
				</el-table-column>
				<el-table-column prop="backupStatus" :label="tableTextConfig.backupStatus" width="160px">
					<template slot-scope="scope">
						<el-tag :type="getTagType(scope.row.backupStatus)">{{ getTagLabel(scope.row.backupStatus) }}</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="exam_type" :label="tableTextConfig.lastOperationTime" width="200px">
					<template slot-scope="scope">
						<p>{{scope.row.updatedByUsername || scope.row.createdByUsername}}</p>
						<p class="updateDate">{{scope.row.updatedAt ? formatDateTime(scope.row.updatedAt) : formatDateTime(scope.row.createdAt)}}</p>
					</template>
				</el-table-column>
				<el-table-column fixed="right" :label="tableTextConfig.operate" width="200px">
					<template slot-scope="scope">
						<el-button v-hasPermi="['backup:backing']" plain type="success" size="mini" v-if="scope.row.backupStatus === 'online' || scope.row.backupStatus === 'fail' || scope.row.backupStatus === 'nodata'" @click="backup([scope.row])">
							{{ tableButtonTextConfig.backing.name }}
						</el-button>
						<el-button v-hasPermi="['backup:download']" plain type="primary" size="mini" v-if="scope.row.backupStatus === 'backed'" @click="download([scope.row])">
							{{ tableButtonTextConfig.donwload.name }}
						</el-button>
						<el-button v-hasPermi="['backup:delete']" plain type="danger" size="mini" v-if="scope.row.backupStatus == 'online' || scope.row.backupStatus == 'backed' || scope.row.backupStatus === 'fail' || scope.row.backupStatus === 'nodata'" @click="del([scope.row])">
							{{ tableButtonTextConfig.remove.name }}
						</el-button>
					</template>
				</el-table-column>
			</el-table>
			<backup-dialog :items.sync="items" :show.sync="backupDialogVisible" :type.sync="type" @close="close" @cancel="cancel"></backup-dialog>
			<pagination v-show="tableData.length" :currentPage.sync="form.pageNumber" :pageSize.sync="form.pageSize" :total.sync="total"></pagination>
		</div>
	</div>
</template>

<script>
    import pagination from '@/components/pagination/pagination.vue'
    import backupDialog from './components/backupDialog'
    import {getSummary} from "@/api/backup";

    export default {
        components: {
            pagination,
            backupDialog
        },
        data() {
            return {
                height: 250,
                loading: true,
                form: {
                    examPlanId: '', // 竞赛计划
                    subjectId: '', // 赛项名称
                    examPlanName: '', // 竞赛计划
                    subject: '', // 赛项名称
                    ids: '',
                    pageNumber: 1,
                    pageSize: 20
                },
                total: 0,
                statusOptions: [
                    {
                        value: 'online',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.online,
                        type: 'primary'
                    },
                    {
                        value: 'backing',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.backing,
                        type: 'warning'
                    },
                    {
                        value: 'backed',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.backed,
                        type: 'success'
                    },
                    {
                        value: 'fail',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.fail,
                        type: 'danger'
                    },
                    {
                        value: 'nodata',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.nodata,
                        type: 'warning'
                    },
                    {
                        value: 'deleted',
                        label: this.$store.state.global.textConfig.backend.backup.statusEnum.deleted,
                        type: 'info'
                    }
                ],
                tableData: [],
                summaryData: {
                    total: '0',
                    count: '0 MB'
                },
                row: null,
                selectRow: [],
                backupDialogVisible: false,
                items: [],
                type: '',
                examPlanOptions: [],
                subjectOptions: [],
            }
        },
        computed: {
            backupTextConfig() {
                return this.$store.state.global.textConfig.backend.backup
            },
            searchTextConfig() {
                return this.backupTextConfig.search
            },
            batchTextConfig() {
                return this.backupTextConfig.batch
            },
            infoTextConfig() {
                return this.backupTextConfig.info
            },
            tableTextConfig() {
                return this.backupTextConfig.table
            },
            tableButtonTextConfig() {
                return this.tableTextConfig.button
            },
        },
        watch: {
            tableData() {
                if (this.tableData.length == 0) {
                    this.height = 120
                } else {
                    this.updateHeight()
                }
            }
        },
        methods: {
            getData() {
                this.$store.dispatch("getExamPlan").then(res => {
                    this.examPlanOptions = res.data
                });
                this.$store.dispatch("getExamSubject").then(res => {
                    this.subjectOptions = res.data
                });
            },
            getTagType(val) {
                for (let i = 0; i < this.statusOptions.length; i++) {
                    const e = this.statusOptions[i];
                    if (e.value === val) {
                        return e.type
                    }
                }
            },
            getTagLabel(val) {
                for (let i = 0; i < this.statusOptions.length; i++) {
                    const e = this.statusOptions[i];
                    if (e.value === val) {
                        return e.label
                    }
                }
            },
            search(val) {
                this.loading = true
		            this.getSummary()
                if (val) {
                    this.form.pageNumber = val
                }
                let form = JSON.parse(JSON.stringify(this.form))
                this.$store.dispatch("getBackupList", form).then(res => {
                    if (res.status == 200) {
                        this.tableData = res.data.list
                        this.total = res.data.total
                    }
                    this.loading = false
                    this.$refs.multipleTable.bodyWrapper.scrollTop = 0;
                }).catch(err => {
                    console.log(err);
                    this.loading = false
                })
            },
            reset() {
                this.form = {
                    examPlanId: '', // 竞赛计划
                    subjectId: '', // 赛项名称
                    examPlanName: '', // 竞赛计划
                    subject: '', // 赛项名称
                    ids: '',
                    pageNumber: 1,
                    pageSize: 20
                }
                this.form.pageSize = 20
                this.search(1)
            },
            handleSelectionChange(val) {
                this.selectRow = val
            },
            getSummary() {
                getSummary().then(res => {
                    if (res.status === 200) {
                        this.summaryData = {...res.data}
                    }
                })
            },
            backup(rows) {
                this.type = 'backup'
                this.items = [...rows]
                if (this.items) {
                    this.backupDialogVisible = true
                }
            },
            download(rows) {
                this.type = 'download'
                this.items = [...rows]
                if (this.items) {
                    this.backupDialogVisible = true
                }
            },
            del(rows) {
                this.type = 'del'
                this.items = [...rows]
                if (this.items) {
                    this.backupDialogVisible = true
                }
            },
            cancel(val) {
                this.backupDialogVisible = val
            },
            close(val) {
                this.backupDialogVisible = val
                this.items = []
                this.search(this.form.pageNumber)
            },
            updateHeight() {
                if (document.getElementsByClassName('el-form')[0]) {
                    this.height = document.getElementsByClassName('board')[0].clientHeight - document.getElementsByClassName('el-form')[0].clientHeight - 190
                    this.height = this.height < 460 ? 460 : this.height
                }
            },
            examTimeFormatter(row) {
                if (row && row.startTime && row.endTime) {
                    return row.startTime + ' ~ ' + row.endTime
                } else {
                    return ''
                }
            },
            formatDateTime(timestamp, format = 'YYYY-MM-DD HH:mm') {
                if (!timestamp) return ''
                const date = new Date(timestamp * 1000)

                const formatMap = {
                    'YYYY': date.getFullYear(),
                    'MM': String(date.getMonth() + 1).padStart(2, '0'),
                    'DD': String(date.getDate()).padStart(2, '0'),
                    'HH': String(date.getHours()).padStart(2, '0'),
                    'mm': String(date.getMinutes()).padStart(2, '0'),
                    'ss': String(date.getSeconds()).padStart(2, '0'),
                    'SSS': String(date.getMilliseconds()).padStart(3, '0')
                }

                return format.replace(/(YYYY|MM|DD|HH|mm|ss|SSS)/g, match => formatMap[match])
            },
            formatFileSize(bytes, decimalPlaces = 2) {
                if (bytes === 0) return '0 KB';

                const k = 1024;

                // 统一以KB为基准单位进行计算
                const kbValue = bytes / k;

                // 如果小于1KB，直接返回
                if (kbValue < 1) {
                    return parseFloat(kbValue.toFixed(decimalPlaces)) + ' KB';
                }

                const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
                const i = Math.floor(Math.log(kbValue) / Math.log(k));

                return parseFloat((kbValue / Math.pow(k, i)).toFixed(decimalPlaces)) + ' ' + sizes[i];
            }
        },
        created() {
		        this.getData()
            this.search(1)
        },
        mounted() {
            const that = this;
            setTimeout(() => {
                that.updateHeight()
            }, 200);
            window.onresize = () => {
                that.updateHeight()
            };
        },
    }
</script>

<style scoped>
	.info {
		color: #555;
		font-size: 15px;
		margin-bottom: 12px;
	}

	.info span {
		color: #C0C4CC;
		margin-left: 12px;
	}

	.info i {
		color: #555;
	}

	.spaceBetween {
		display: flex;
		justify-content: space-between;
	}
</style>
